export default __webpack_public_path__ + "static/media/mobiledev-445x660.a2fd064f.png";